<div>
  <p class="auth-desc auth-register-desc" *ngIf="isFromMobileFlow()">
    {{ 'pages.register.step2.descriptionMobile' | i18n }}
  </p>
  <p class="auth-desc auth-register-desc" *ngIf="!isFromMobileFlow() && !hideAuthRegisterLink">
    {{ 'pages.register.step2.description' | i18n }}
  </p>
  <form [formGroup]="step2Form" class="auth-form" (ngSubmit)="nextStep()">
    <div class="input-group">
      <umkt-custom-input 
        formControlName="cep" 
        id="cep" 
        [ariaLabel]="'pages.register.step2.cep.label' | i18n" 
        [placeholder]="'pages.register.step2.cep.placeholder' | i18n"
        mask='00000-000'>
      </umkt-custom-input>
      <div *ngIf="step2Form.get('cep')?.errors?.['invalidCEP'] && step2Form.get('cep')?.touched" class="field-error">
        {{ 'pages.register.step2.cep.errorInvalid' | i18n }}
      </div>
    </div>
    <div class="input-group">
      <umkt-custom-input 
        formControlName="endereco" 
        id="endereco" 
        [ariaLabel]="'pages.register.step2.address.label' | i18n" 
        [placeholder]="'pages.register.step2.address.placeholder' | i18n"
        [maxlength]="255" 
        (keydown)="preventLeadingSpace($event)">
      </umkt-custom-input>
      <div *ngIf="step2Form.get('endereco')?.hasError('maxlength') && step2Form.get('endereco')?.touched" class="field-error">
        {{ 'pages.register.step2.address.errorMax' | i18n }}
      </div>
    </div>
    <div style="display: flex; gap: 1rem;">
      <umkt-custom-input 
        formControlName="numero" 
        id="numero" 
        [ariaLabel]="'pages.register.step2.number.label' | i18n" 
        [placeholder]="'pages.register.step2.number.placeholder' | i18n"
        [maxlength]="20" 
        (keydown)="preventLeadingSpace($event)">
      </umkt-custom-input>
      
      <umkt-custom-input 
        formControlName="complemento" 
        id="complemento" 
        [ariaLabel]="'pages.register.step2.complement.label' | i18n"
        [placeholder]="'pages.register.step2.complement.placeholder' | i18n" 
        [maxlength]="100"
        (keydown)="preventLeadingSpace($event)">
      </umkt-custom-input>
    </div>

    <umkt-custom-input 
      formControlName="bairro" 
      id="bairro" 
      [ariaLabel]="'pages.register.step2.district.label' | i18n" 
      [placeholder]="'pages.register.step2.district.placeholder' | i18n" 
      [maxlength]="100"
      (keydown)="preventLeadingSpace($event)">
    </umkt-custom-input>
    <div style="display: flex; gap: 1rem;">
      <div class="form-field state-field">
        <select id="estado" class="form-select form-control"
          [class.error]="step2Form.get('estado')?.invalid && step2Form.get('estado')?.touched" 
          formControlName="estado"
          required>
          <option value="">{{ 'pages.register.step2.state.defaultOption' | i18n }}</option>
          <option *ngFor="let state of brazilStates" [value]="state.value">
            {{ state.label }}
          </option>
        </select>
      </div>

      <div class="form-field">
        <div class="city-input-container">
          <umkt-custom-input 
            id="cidade" 
            type="text"
            [class.error]="step2Form.get('cidade')?.invalid && step2Form.get('cidade')?.touched"
            [placeholder]="'pages.register.step2.city.placeholder' | i18n" 
            formControlName="cidade"
            (keydown)="onCityKeydown($event)" 
            autocomplete="off"
            required>
          </umkt-custom-input>
          
          <div *ngIf="showCitySuggestions && filteredCities.length > 0" class="city-suggestions">
            <div *ngFor="let city of filteredCities; let i = index" class="city-suggestion-item"
              [class.selected]="i === selectedSuggestionIndex" 
              (click)="selectCity(city)"
              (mouseenter)="selectedSuggestionIndex = i">
              {{ city }}
            </div>
          </div>
        </div>
        <div *ngIf="step2Form.get('cidade')?.errors?.['invalidCity'] && step2Form.get('cidade')?.touched" class="field-error">
          {{ 'pages.register.step2.city.errorNotFound' | i18n }}
        </div>
      </div>
    </div>
    <div class="input-group" *ngIf="isFromMobileFlow()">
      <umkt-custom-input 
        formControlName="fullName" 
        id="fullName" 
        [ariaLabel]="'pages.register.step2.fullName.label' | i18n" 
        [placeholder]="'pages.register.step2.fullName.placeholder' | i18n" 
        [maxlength]="255" 
        (keydown)="preventLeadingSpace($event)">
      </umkt-custom-input>
      
      <div *ngIf="step2Form.get('fullName')?.errors?.['required'] && step2Form.get('fullName')?.touched" class="field-error">
        {{ 'pages.register.step2.fullName.errorRequired' | i18n }}
      </div>
      <div *ngIf="step2Form.get('fullName')?.errors?.['invalidFullName'] && step2Form.get('fullName')?.touched" class="field-error">
        {{ 'pages.register.step2.fullName.errorInvalid' | i18n }}
      </div>
    </div>
    <ustore-button type="submit" [text]="getButtonText()" [disabled]="step2Form.invalid || loading || !citySelectedFromList" [full]="true"
      [backgroundColor]="'var(--color-red-500-to-yellow)'" [textColor]="'var(--color-inverted)'" [format]="'filled'" [size]="'medium'"
      [rounded]="'default'"
      [icon]="getButtonIcon()">
    </ustore-button>
    
    <div *ngIf="loading" class="loading-indicator">
      <p>{{ 'pages.register.step2.searchingAddress' | i18n }}</p>
    </div>
    <div class="auth-register" *ngIf="!isFromMobileFlow() && !hideAuthRegisterLink">
      {{ 'shared.auth.hasAccount' | i18n }} <a (click)="goToLogin()">{{ 'shared.buttons.login' | i18n }}</a>
    </div>
  </form>
</div>


